import cn from 'classnames';
import React__default from 'react';
import { Accordion, Badge, Menu, Typography, Dialog, Sheet } from '@sravni/react-design-system';
import { Space } from '@sravni/react-design-system/lib/Space';
import { useStyles, useIsMobile, useBoolean } from '@sravni/react-utils';
import { hasItem, generateKeyFromTab } from '@sravni/ugc/lib/specialOffers/helpers';
import { COMMON_OFFERS_LIST, EDUCATION_OFFERS_LIST, BUSINESS_OFFERS_LIST, INSURANCE_OFFERS_LIST, INSURANCE_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';
import { generateHeadingTitle } from '../../helpers/generateHeadingTitle.js';
import { getTabTitle, getTabTitleTo } from '../../helpers/getTitle.js';
import modules_31ab199a from './Headings.module.scss.js';

const allTabsForMenu = [
    { label: 'Личные финансы', list: COMMON_OFFERS_LIST },
    { label: 'Онлайн-курсы', list: EDUCATION_OFFERS_LIST },
    { label: 'Бизнес', list: BUSINESS_OFFERS_LIST },
    { label: 'Страхование', list: INSURANCE_OFFERS_LIST },
];
const PopoverHeading = ({ element, activeTabType, tabs, onTabChange, isLimitTabsCount, }) => {
    const cx = useStyles(modules_31ab199a);
    const isMobile = useIsMobile();
    const [isPopupVisible, setPopupVisibility] = useBoolean();
    let tabsToShow = allTabsForMenu;
    if (isLimitTabsCount) {
        tabsToShow = allTabsForMenu.reduce((acc, { label, list }) => {
            const availableTabs = list.filter(tab => hasItem(tabs, tab));
            if (!availableTabs.length)
                return acc;
            return [...acc, { label, list: availableTabs }];
        }, []);
    }
    if (tabs[0]?.type === INSURANCE_OFFERS.insuranceOsago) {
        return React__default.cloneElement(React__default.createElement(React__default.Fragment, null), {}, null);
    }
    const popupLayoutContent = (React__default.createElement(Accordion, { defaultIndex: [0], separator: 'divider' }, tabsToShow.map(({ label, list }) => {
        const labelElement = (React__default.createElement(Space, { direction: 'horizontal', size: 8, align: 'center' },
            React__default.createElement("span", null, label),
            React__default.createElement(Badge, { variant: 'primary', color: 'blue', text: list.length, className: cx('menu__heading__badge') })));
        return (React__default.createElement(Accordion.Item, { title: labelElement, className: cx('accordion-item'), key: `label-${label}` },
            React__default.createElement(Menu, { className: cx('menu') }, list.map(tab => {
                const handleMenuItemClick = () => {
                    onTabChange(tab);
                    setPopupVisibility.off();
                };
                return (React__default.createElement(Menu.Item, { key: generateKeyFromTab(tab), active: tab.type === activeTabType.type && tab.subtype === activeTabType.subtype, onClick: handleMenuItemClick },
                    React__default.createElement("span", { className: cx('menu__item') }, getTabTitle(tab))));
            }))));
    })));
    const children = tabs.length === 1 ? (`${generateHeadingTitle(activeTabType)} ${getTabTitleTo(activeTabType)}`) : (React__default.createElement(React__default.Fragment, null,
        generateHeadingTitle(activeTabType),
        ' ',
        React__default.createElement(Typography.Link, { onClick: setPopupVisibility.on }, getTabTitleTo(activeTabType)),
        !isMobile && (React__default.createElement(Dialog, { visible: isPopupVisible, onClose: setPopupVisibility.off, className: cx('dialog') },
            React__default.createElement(Dialog.Header, { title: "\u0418\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F" }),
            React__default.createElement(Dialog.Content, null, popupLayoutContent))),
        isMobile && (React__default.createElement(Sheet, { visible: isPopupVisible, onClose: setPopupVisibility.off, closable: true, fullscreen: true },
            React__default.createElement(Sheet.Header, { title: 'Интересные предложения' }),
            React__default.createElement(Sheet.Content, null, popupLayoutContent)))));
    const propsForCloningElement = {
        ...element.props,
        className: cn('h-mb-20', element.props.className),
    };
    return React__default.cloneElement(element, propsForCloningElement, children);
};

export { PopoverHeading };
//# sourceMappingURL=PopoverHeading.js.map
